export default "__VITE_ASSET__DuGWj11F__"